/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shell_Tab_PlanInputs */

const en_us2_shell_tab_plan = /** @type {(inputs: Shell_Tab_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const pt_br2_shell_tab_plan = /** @type {(inputs: Shell_Tab_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano`)
};

const es_419_shell_tab_plan = /** @type {(inputs: Shell_Tab_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const pt_pt2_shell_tab_plan = /** @type {(inputs: Shell_Tab_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano`)
};

const fr_fr2_shell_tab_plan = /** @type {(inputs: Shell_Tab_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme`)
};

const de_de2_shell_tab_plan = /** @type {(inputs: Shell_Tab_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const it_it2_shell_tab_plan = /** @type {(inputs: Shell_Tab_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheda`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Shell_Tab_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_tab_plan = /** @type {((inputs?: Shell_Tab_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Tab_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_tab_plan(inputs)
	if (locale === "es-419") return es_419_shell_tab_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_tab_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_tab_plan(inputs)
	if (locale === "de-DE") return de_de2_shell_tab_plan(inputs)
	if (locale === "it-IT") return it_it2_shell_tab_plan(inputs)
	return en_us2_shell_tab_plan(inputs)
});
export { shell_tab_plan as "shell.tab_plan" }